import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  "data-cy": "action-modal",
  class: "relative flex flex-col select-none max-w-sm"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row pt-6 pb-4 pr-6"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_4 = { class: "text-xl font-semibold text-center text-gray-900" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4 text-center text-gray-500 whitespace-pre-line"
}
const _hoisted_6 = { class: "space-y-3 mt-8 w-full" }

import { computed, PropType } from 'vue';
import { ColorName, IModalAction } from '@/lib';
import { BaseButton } from '@/lib/components/Button';
import { BaseIcon } from '@/lib/components/Icon';
import BaseModal from './BaseModal.vue';
import { colors } from '@/lib/constants';
import IconGlyph from '@/lib/components/Icon/IconGlyph.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionModal',
  props: {
  iconColor: {
    type: String as PropType<ColorName>,
    default: 'primary-500'
  },
  icon: {
    type: String,
    default: null
  },
  iconBgColor: {
    type: String as PropType<ColorName | null>,
    default: null,
    validator: (value: ColorName): boolean => value === null || colors.includes(value)
  },
  stroke: {
    type: Boolean,
    default: true
  },
  isGlyph: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  body: {
    type: String,
    default: ''
  },
  actions: {
    type: Array as PropType<Array<IModalAction>>,
    default: () => []
  },
  danger: {
    type: Boolean,
    default: false
  },
  showClose: {
    type: Boolean,
    default: true
  }
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const iconBgClasses = computed(() => props.iconBgColor ? `bg-${props.iconBgColor} rounded-xl p-3` : '');

const close = () => {
  emit('close');
};
const onActionClick = (action: IModalAction, event: MouseEvent) => {
  action.onClick(event);
  event.stopPropagation();
  close();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    danger: __props.danger,
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.showClose)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("button", {
                type: "button",
                onClick: close
              }, [
                _createVNode(_unref(BaseIcon), {
                  class: "text-gray-400",
                  name: "close"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col items-center px-8 pb-8", { 'pt-10': !__props.showClose }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["mb-5", _unref(iconBgClasses)])
          }, [
            (__props.icon)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (__props.isGlyph)
                    ? (_openBlock(), _createBlock(IconGlyph, {
                        key: 0,
                        name: __props.icon,
                        color: __props.iconColor,
                        size: "large"
                      }, null, 8, ["name", "color"]))
                    : (_openBlock(), _createBlock(_unref(BaseIcon), {
                        key: 1,
                        class: _normalizeClass(["text-5xl", 'text-' + __props.iconColor]),
                        name: __props.icon,
                        height: "32px",
                        stroke: __props.stroke
                      }, null, 8, ["class", "name", "stroke"]))
                ], 64))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1),
          (__props.body.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.body), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action) => {
              return (_openBlock(), _createBlock(_unref(BaseButton), {
                key: action.label,
                block: "",
                size: "large",
                class: "w-full",
                "data-dusk": `${action.label.toLowerCase().split(' ').join('-')}-btn`,
                color: action.color,
                onClick: ($event: any) => (onActionClick(action, $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(action.label), 1)
                ]),
                _: 2
              }, 1032, ["data-dusk", "color", "onClick"]))
            }), 128)),
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2)
      ])
    ]),
    _: 3
  }, 8, ["danger"]))
}
}

})